import React from 'react';
import { Link } from 'react-router-dom';
import { STATIC_PATH_S3 } from '../../config';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__inner">
          <div className="footer__left">
            <Link className="footer__logo footer__logo--light" to="/publisher/sign_in">
              <img
                className="footer__logo-img"
                src={`${STATIC_PATH_S3}main-page/footer-logo.svg`}
                alt="Affiliate"
                width="134"
                height="26"
              />
              <span className="footer__logo-subtext">Партнерская программа</span>
            </Link>
            <div className="footer__copyrights">
              <p className="footer__copyrights-text">
                © OOO «ДИДЖИТАЛ КОНТЕНТ»
                <br />
                2022 - 2026
              </p>
              <a
                className="footer__copyrights-text footer__copyrights-text-email"
                href="mailto:support@affiliate.tutorplace.ru"
              >
                support@affiliate.tutorplace.ru
              </a>
            </div>
          </div>
          <div className="footer__right">
            <ul className="footer__list">
              <li className="footer__list-item">
                <a
                  className="footer__list-item-link"
                  href="https://static.tutorplace.ru/docs/affiliate/partners.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Партнерское соглашение
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  className="footer__list-item-link"
                  href="https://static.tutorplace.ru/docs/affiliate/privacy_policy.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Политика конфиденциальности
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  className="footer__list-item-link"
                  href="https://static.tutorplace.ru/docs/affiliate/personal_data.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Согласие на обработку персональных данных
                </a>
              </li>
              <li className="footer__list-item">
                <a
                  className="footer__list-item-link"
                  href="https://static.tutorplace.ru/docs/affiliate/edo.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Соглашение об ЭДО
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
